import { useHMSPeersList } from "../hms";
import { useLivekitPeersList } from "../livekit";
import type { ProviderPeersList } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderPeersList = (): ProviderPeersList =>
  useProviderHook({
    hms: useHMSPeersList,
    livekit: useLivekitPeersList,
  })();
